import axios from "axios";
export const BASE_URL = "https://mallarani.hamropalika.org";
export const baseURLAPI = "https://mallarani.hamropalika.org/api";
export default axios.create({
        baseURL: `${BASE_URL}/api/website/cache/`,
});

